/**
 * @deprecated This function is deprecated. Use tokenTypeKey instead.
 */
export const deprecatedLoginModeKey = 'qlub-role';

export const tokenTypeKey = 'qlub.tokenType';

/**
 * @deprecated This function is deprecated. Use accessTokenKey instead.
 */
export const deprecatedAccessTokenKey = 'token';

export const accessTokenKey = 'qlub.accessToken';

/**
 * @deprecated This function is deprecated. Use refreshTokenKey instead.
 */
export const deprecatedRefreshTokenKey = 'refreshToken';

export const refreshTokenKey = 'qlub.refreshToken';

/**
 * @deprecated This function is deprecated. Use cognitoTokenKey instead.
 */
export const deprecatedCognitoTokenKey = 'accessToken';

export const cognitoTokenKey = 'qlub.cognitoToken';

/**
 * @deprecated This function is deprecated. Use restaurantIdKey instead.
 */
export const deprecatedChosenRestaurantIdKey = 'restaurantId';

export const restaurantIdKey = 'qlub.restaurantId';

/**
 * @deprecated This function is deprecated. Use posVendorKey instead.
 */
export const deprecatedPosVendorKey = 'posVendor';

export const posVendorKey = 'qlub.posVendor';

/**
 * @deprecated This function is deprecated. Use userIdKey instead.
 */
export const deprecatedUserIdKey = 'userId';

export const userIdKey = 'qlub.userId';

/**
 * @deprecated This function is deprecated. Use userNameKey instead.
 */
export const deprecatedUsernameKey = 'qlub-user-name';

export const usernameKey = 'qlub.username';

/**
 * @deprecated This function is deprecated. Use userRoleKey instead.
 */
export const deprecatedUserRoleKey = 'qlub-user-role';

export const userRoleKey = 'qlub.userRole';

/**
 * @deprecated This function is deprecated. Use countryCode instead.
 */
export const deprecatedCountryCodeKey = 'countryCode';

export const countryCodeKey = 'qlub.countryCode';

/**
 * @deprecated This function is deprecated. Use timezoneKey instead.
 */
export const deprecatedTimezoneKey = 'qlub-restaurant-timezone';

export const timezoneKey = 'qlub.timezone';
